import { Training } from './training';
import { Image } from './image';
import { Demo } from './demo';
import { CartItem } from './cartItem';
import { Metadata } from './metadata';
import { Division } from './division';
export class Course {
    public id?: string;
    public name?: string;
    public bookable?: boolean;
    public courseName?: string;
    public courseId?: string;
    public unicodeTitle?: string;
    public dateCreated?: Date | string;
    public training: Training;
    public price: number;
    public url: string;
    public demo?: Demo;
    public categoryId: string;
    public categoryName?: string;
    public descriptionShort: string;
    public image?: Image;
    public events?: CartItem[];
    public type?: string;
    public provider?: string;
    public trainingSegments?: string[];
    public productAreas?: string[];
    public metadata: Metadata;
    public isProduct: boolean;
    public bookings?: number;
    public externalCourseNumber: string;
    public keyWords: string[];
    public duration?: string;
    public prices?: any[];
    public productType?: string;
    public divisions?: Division[];
    public language?: string;
    public hasRequiredQualifications?: boolean;
    public requiredQualifications?: {
        qualificationName: string;
        qualificationId: string;
        mediatingCourses: {
            id: string;
            name: string;
        }[];
    }[];

    constructor(data) {
        this.id = data.id || null;
        this.name = data.name || null;
        this.courseName = data.courseName || null;
        this.bookable = data.bookable || null;
        this.courseId = data.courseId || null;
        this.unicodeTitle = data.unicodeTitle || null;
        this.price = data.price || null;
        this.training = data.training || null;
        this.dateCreated = data.dateCreated || null;
        this.url = data.url || null;
        this.demo = data.demo || null;
        this.categoryId = data.categoryId || null;
        this.categoryName = data.categoryName || null;
        this.descriptionShort = data.descriptionShort || null;
        this.image = data.image || null;
        this.events = data.events || null;
        this.type = data.type || null;
        this.provider = data.provider || null;
        this.trainingSegments = data.trainingSegments || null;
        this.productAreas = data.productAreas || null;
        this.metadata = data.metadata || null;
        this.isProduct = data.isProduct || null;
        this.bookings = data.bookings || 0;
        this.externalCourseNumber = data.externalCourseNumber || null;
        this.keyWords = data.keyWords || null;
        this.duration = data.duration || null;
        this.prices = data.prices || null;
        this.divisions = data.divisions || null;
        this.language = data.language || null;
        this.hasRequiredQualifications = data.hasRequiredQualifications || null;
        this.requiredQualifications = data.requiredQualifications || null;
    }
}
